<template>
  <v-container v-if='loaded' fill-height fluid grid-list-xl>

    <v-dialog v-model="openAuditTrail" max-width="1200px">
      <app-audit-trail-timeline entity="fullyused" v-if='openAuditTrail' :entity_id="fullyused_id" :fields='config.fields'/>
    </v-dialog>

    <v-flex>
      <app-upsert ref='upsert' :config="config" :item="fullyused" title="Fully Used Drugs"
        :subtitle="fullyused.protocol.name" :readonly="fullyused.status === 'CONFIRMED'" hide-save>

        <template slot='headerActions'>
          <app-audit-trail-btn @click="openAuditTrail = true" />
          <app-patch v-if='fullyused.id && isAdmin && fullyused.status === "CONFIRMED"' entity="fullyused" :entity_id="fullyused.id" :protocol_id="fullyused.protocol_id"/>

          <v-btn color="red" @click="$router.push('/fullyused')">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </template>

        <template v-slot:actions="{ item }">

          <v-btn v-if="fullyused.labels_pdf && fullyused.status === 'CONFIRMED'" class="mx-1"
            color="purple darken-2 white--text" :href='`${BASE_URL}/pdf/${fullyused.labels_pdf}`'>
             DOCUMENTATION
            <v-icon right>mdi-file-pdf-box</v-icon>
          </v-btn>


          <v-btn id='confirm_btn' v-if="fullyused.status === 'INIT'" class="mx-1 font-weight-light" color="primary" :loading="loading"
            :disabled="!nDrugs || loading" @click="confirm(item)">CONFIRM</v-btn>

          <app-table :title="`Fully used ${fullyused.labels ? 'labels' : 'drugs'}`"
            :config="fullyused.labels ? labelConfig : drugConfig" upsert-max-width="850px" @loaded="loadedDrugs"
            :hide-upsert="fullyused.status === 'CONFIRMED'" :hide-actions="fullyused.status === 'CONFIRMED'"
            :filters="{ fullyused_id }" no-search
            :hidden-fields="{ fullyused_id, protocol_id: fullyused.protocol_id, site_id: fullyused.site_id, lotto: '' }" />

        </template>

      </app-upsert>

    </v-flex>

  </v-container>
</template>

<script>
/* eslint-disable no-case-declarations */

import config from './config_index.js'
import drugConfig from './drug_index.js'
import labelConfig from './label_index.js'
const { getDetail } = require('@/api/base_entity')
const { confirmFullyused } = require('@/api/fullyused')
import { mapState } from 'vuex'
const BASE_URL = process.env.VUE_APP_BASE_API

// const { updateAvailableSerials } = require('@/api/response')
// const { updateSiteResponse } = require('@/api/siterequest')

export default {
  data() {
    return {
      BASE_URL,
      config,
      drugConfig,
      labelConfig,
      fullyused_id: null,
      nDrugs: 0,
      drugs: [],
      fullyused: {},
      loaded: false,
      loading: false,
      openAuditTrail: false
    }
  },
  async created() {
    this.fullyused_id = Number(this.$route.params.fullyusedId)
    this.fullyused = await getDetail('fullyused', { id: this.fullyused_id })
    this.loaded = true
  },
  computed: {
    ...mapState(['user']),
    isAdmin () {
      return this.user.role === 'Administrator' || this.user.role === 'EMN User'
    },
  },
  methods: {
    loadedDrugs(items) {
      this.drugs = items
      this.nDrugs = items.length
    },
    async confirm(item) {
      if (!this.$refs.upsert.validate()) return
      this.loading = true

      try {
        const formData = new FormData()
        formData.append('pdf', item['pdf'])
        await confirmFullyused(this.fullyused_id, formData)
        this.$router.go()
      } catch (e) {
        this.$root.$emit('openSnackbar', {
          message: 'An Error occurred. ' +
            e && e.response ? e.response.data.message : 'Error',
          color: 'error'
        })
        this.loading = false
      }
    },
  }
}
</script>
